document.addEventListener('DOMContentLoaded', function () {
    function getVariantId() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariant = urlParams.get('variant');
        if (urlVariant) return urlVariant;

        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) return variantInput.value;

        return null;
    }

    function getQuantity() {
        const quantityInput = document.querySelector('input[name="quantity"]') || document.querySelector(".product [name='cust_quantity']");
        return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    }

    function redirectToCheckout(variantId, quantity = 1) {
        if (!variantId) {
            console.error('No variant ID found');
            return;
        }

        const checkoutUrl = `https://groundluxe.myshopify.com/cart/${variantId}:${quantity}?checkout`;
        window.location.href = checkoutUrl;
    }

    const buyNowButton = document.getElementById('buy-now-button');
    if (buyNowButton) {
        buyNowButton.addEventListener('click', function () {
            const variantId = getVariantId();
            const quantity = getQuantity();

            buyNowButton.disabled = true;
            buyNowButton.classList.add('loading');
            buyNowButton.innerHTML = `<span class="spinner"></span> Loading...`;

            redirectToCheckout(variantId, quantity);
        });
    }
});